import ReactDOM from "react-dom";
import NsLoader from "components/ui/ns-loader";

/* Full-screen wait. One motion per waiting state, so the brand loader is the
   only thing moving here — no spinner beside it.

   The loader spec prefers mounting in place of the content rather than over it;
   this barrier stays a barrier because generation must block interaction, but
   the pill itself is the standard component on the dark variant. */

const ScaleBarrierLoader = ({ text }) =>
  ReactDOM.createPortal(
    <div className="fixed inset-0 z-[1000] flex h-screen w-screen items-center justify-center bg-ink/70 backdrop-blur-[2px]">
      <NsLoader dark label={text} />
    </div>,
    document.body
  );

export default ScaleBarrierLoader;
